import script from "./masterLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./masterLayout.vue?vue&type=script&lang=ts&setup=true"

import "./masterLayout.vue?vue&type=style&index=0&id=65407f39&lang=scss"

const __exports__ = script;

export default __exports__